import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getAssetUrl } from "../config";
import { useModal } from "../context/ModalContext";
// import axios from "axios";

export default function Header() {
  const { openModal } = useModal();
  const location = useLocation();
  const servicePaths = new Set([
    "/after-hours-noc-support",
    "/angularjs",
    "/cakephp",
    "/custom-cms",
    "/custom-php-software-solutions",
    "/digital-marketing-services",
    "/drupal",
    "/expertise",
    "/laravel",
    "/magento",
    "/managed-cloud-migration-services",
    "/managed-it-services",
    "/network-monitoring-outsourcing-services",
    "/noc-services",
    "/nodejs",
    "/on-demand-it-support-services",
    "/react-js-development",
    "/react-native",
    "/seo",
    "/server-and-networking-administration",
    "/shopify",
    "/social-media",
    "/virtualization-solutions",
    "/vsa-services",
    "/website-design-&-development",
    "/website-monitoring-and-maintenance",
    "/woocommerce-development",
    "/wordpress-development",
  ]);
  const serviceLinkClass = (path) =>
    location.pathname === path ? "is-active" : "";
  const isServicePage =
    location.pathname === "/services" || servicePaths.has(location.pathname);
  const [navOpen, setNavOpen] = useState(false);
  const [megaOpen, setMegaOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    setNavOpen(false);
    setMegaOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 900) {
        setNavOpen(false);
        setMegaOpen(false);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("nav-lock", navOpen);
    return () => document.body.classList.remove("nav-lock");
  }, [navOpen]);

  const toggleNav = () => setNavOpen((prev) => !prev);
  const closeNav = () => {
    setNavOpen(false);
    setMegaOpen(false);
  };
  return (
    <>
      <header className="site-header">
        <div className="container header-inner">
          <Link to="/" className="logo">
            <img alt="Kudosta" src={getAssetUrl('kds-assets/img/final_logo.png')} />
          </Link>
          <div
            className={`nav-backdrop${navOpen ? " is-visible" : ""}`}
            onClick={closeNav}
          />
          <nav className={`main-nav${navOpen ? " is-open" : ""}`} ref={navRef}>
            <Link
              className={`nav-link${location.pathname === "/" ? " is-active" : ""}`}
              onClick={closeNav}
              to="/"
            >
              Home
            </Link>
            <Link
              className={`nav-link${location.pathname === "/about" ? " is-active" : ""}`}
              onClick={closeNav}
              to="/about"
            >
              About
            </Link>

            <div className="nav-item has-mega">
              <Link
                className={`nav-link nav-link--mega${isServicePage ? " is-active" : ""}`}
                onClick={(event) => {
                  if (window.innerWidth <= 900) {
                    event.preventDefault();
                    setMegaOpen((prev) => !prev);
                  } else {
                    closeNav();
                  }
                }}
                to="/services"
              >
                Services
                <svg className="chev" fill="none" viewBox="0 0 12 12">
                  <path
                    d="M2.5 4.5L6 8l3.5-3.5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.6"
                  ></path>
                </svg>
              </Link>

              <div className={`mega-menu${megaOpen ? " is-open" : ""}`}>
                <div className="container mega-inner mega-inner--groups">
                  <Link
                    className="mega-featured"
                    onClick={closeNav}
                    to="/custom-php-software-solutions"
                  >
                    <span className="blob"></span>
                    <div>
                      <span className="badge">ALL SERVICES</span>
                      <h4>Custom Software Solutions</h4>
                      <p>
                        Bespoke platforms, tools and integrations engineered
                        around your exact workflow — built to scale.
                      </p>
                    </div>
                    <span className="go">Explore all services →</span>
                  </Link>
                  <div className="mega-groups">
                    <div className="mega-group menu-web-development">
                      <h6>Web Development</h6>
                      <div className="mega-group-links">
                        <Link className={serviceLinkClass("/nodejs")} onClick={closeNav} to="/nodejs">
                          Node.js
                        </Link>
                        <Link className={serviceLinkClass("/angularjs")} onClick={closeNav} to="/angularjs">
                          Angular
                        </Link>
                        <Link className={serviceLinkClass("/cakephp")} onClick={closeNav} to="/cakephp">
                          CakePHP
                        </Link>
                        <Link className={serviceLinkClass("/laravel")} onClick={closeNav} to="/laravel">
                          Laravel
                        </Link>
                        <Link
                          className={serviceLinkClass("/custom-php-software-solutions")}
                          onClick={closeNav}
                          to="/custom-php-software-solutions"
                        >
                          Custom PHP
                        </Link>
                        <Link className={serviceLinkClass("/react-js-development")} onClick={closeNav} to="/react-js-development">
                          React JS
                        </Link>
                        <Link
                          className={serviceLinkClass("/website-design-&-development")}
                          onClick={closeNav}
                          to="/website-design-&-development"
                        >
                          Website Design &amp; Development
                        </Link>
                        <Link className={serviceLinkClass("/react-native")} onClick={closeNav} to="/react-native">
                          React Native (Mobile Apps)
                        </Link>
                      </div>
                    </div>
                    <div className="mega-group menu-server-networking">
                      <h6>Server &amp; Networking</h6>
                      <div className="mega-group-links">
                        <Link
                          className={serviceLinkClass("/server-and-networking-administration")}
                          onClick={closeNav}
                          to="/server-and-networking-administration"
                        >
                          Server &amp; Networking Admin
                        </Link>
                        <Link className={serviceLinkClass("/noc-services")} onClick={closeNav} to="/noc-services">
                          Managed NOC Services
                        </Link>
                        <Link className={serviceLinkClass("/vsa-services")} onClick={closeNav} to="/vsa-services">
                          VSA Services
                        </Link>
                        <Link
                          className={serviceLinkClass("/on-demand-it-support-services")}
                          onClick={closeNav}
                          to="/on-demand-it-support-services"
                        >
                          On-Demand IT Support
                        </Link>
                        <Link
                          className={serviceLinkClass("/managed-cloud-migration-services")}
                          onClick={closeNav}
                          to="/managed-cloud-migration-services"
                        >
                          Managed Cloud &amp; Migration
                        </Link>
                        <Link className={serviceLinkClass("/virtualization-solutions")} onClick={closeNav} to="/virtualization-solutions">
                          Virtualization Solutions
                        </Link>
                        <Link className={serviceLinkClass("/after-hours-noc-support")} onClick={closeNav} to="/after-hours-noc-support">
                          After-Hours NOC Support
                        </Link>
                        <Link
                          className={serviceLinkClass("/network-monitoring-outsourcing-services")}
                          onClick={closeNav}
                          to="/network-monitoring-outsourcing-services"
                        >
                          Network Monitoring
                        </Link>
                        <Link className={serviceLinkClass("/managed-it-services")} onClick={closeNav} to="/managed-it-services">
                          Managed IT Services
                        </Link>
                        <Link className={serviceLinkClass("/expertise")} onClick={closeNav} to="/expertise">
                          Server &amp; Network Expertise
                        </Link>
                        <Link
                          className={serviceLinkClass("/website-monitoring-and-maintenance")}
                          onClick={closeNav}
                          to="/website-monitoring-and-maintenance"
                        >
                          Website Monitoring &amp; Maintenance
                        </Link>
                      </div>
                    </div>
                    <div className="mega-group menu-cms-migration">
                      <h6>CMS &amp; Migration</h6>
                      <div className="mega-group-links">
                        <Link className={serviceLinkClass("/wordpress-development")} onClick={closeNav} to="/wordpress-development">
                          WordPress
                        </Link>
                        <Link className={serviceLinkClass("/drupal")} onClick={closeNav} to="/drupal">
                          Drupal
                        </Link>
                        <Link className={serviceLinkClass("/custom-cms")} onClick={closeNav} to="/custom-cms">
                          Custom CMS
                        </Link>
                      </div>
                    </div>
                    <div className="mega-group menu-digital-marketing">
                      <h6>Digital Marketing</h6>
                      <div className="mega-group-links">
                        <Link className={serviceLinkClass("/seo")} onClick={closeNav} to="/seo">
                          SEO
                        </Link>
                        <Link className={serviceLinkClass("/social-media")} onClick={closeNav} to="/social-media">
                          Social Media
                        </Link>
                        <Link className={serviceLinkClass("/digital-marketing-services")} onClick={closeNav} to="/digital-marketing-services">
                          Digital Marketing
                        </Link>
                      </div>
                    </div>
                    <div className="mega-group menu-e-commerce">
                      <h6>E-Commerce</h6>
                      <div className="mega-group-links">
                        <Link className={serviceLinkClass("/magento")} onClick={closeNav} to="/magento">
                          Magento
                        </Link>
                        <Link className={serviceLinkClass("/woocommerce-development")} onClick={closeNav} to="/woocommerce-development">
                          WooCommerce
                        </Link>
                        <Link className={serviceLinkClass("/shopify")} onClick={closeNav} to="/shopify">
                          Shopify
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Link
              className={`nav-link${location.pathname === "/portfolio" ? " is-active" : ""}`}
              onClick={closeNav}
              to="/portfolio"
            >
              Portfolio
            </Link>
            <Link
              className={`nav-link${location.pathname === "/blog" ? " is-active" : ""}`}
              onClick={closeNav}
              to="/blog"
            >
              Blog
            </Link>
            <Link
              className={`nav-link${location.pathname === "/career" ? " is-active" : ""}`}
              onClick={closeNav}
              to="/career"
            >
              Career
            </Link>
            <Link
              className={`nav-link${location.pathname === "/contact" ? " is-active" : ""}`}
              onClick={closeNav}
              to="/contact"
            >
              Contact
            </Link>
          </nav>
          <button
            className="btn btn-primary btn--sm"
            onClick={openModal}
            type="button"
          >
            Start a project
          </button>

          <button
            aria-label="Menu"
            className={`nav-toggle${navOpen ? " is-open" : ""}`}
            onClick={toggleNav}
            type="button"
          >
            <span></span>
          </button>
        </div>
      </header>
    </>
  );
}
